import { createAction } from 'redux-actions'

export const openModal = (reducerName: string) => createAction(`${reducerName}.OPEN_MODAL`)
export const closeModal = (reducerName: string) => createAction(`${reducerName}.CLOSE_MODAL`)
